import { useEffect, useState } from "react";
import CloseIcon from "../../assets/icons/close.svg";

import "../../utils/styles/modal.css";
import "./ModalEditFaq.css";
import { contentService } from "../../services/content.service";
import { closeModal, showModal } from "../../utils/functions/modal";

const ModalEditFaq = ({ setMessage, faq, onSuccess }) => {
  const [titulo, setTitulo] = useState("");
  const [respuesta, setRespuesta] = useState("");
  const [orden, setOrden] = useState(0);

  useEffect(() => {
    setTitulo(faq?.titulo || "");
    setRespuesta(faq?.respuesta || "");
    setOrden(faq?.orden ?? 0);
  }, [faq]);

  const handleSubmitFaq = async (e) => {
    e.preventDefault();
    if (!faq?.id) return;

    closeModal(".container-modal-edit-faq");
    showModal(".container-modal-confirm");
    setMessage({
      description: "Editando pregunta...",
      status: 1000,
    });

    const response = await contentService.editFaq({
      id: faq.id,
      titulo: titulo.trim(),
      respuesta: respuesta.trim(),
      orden: parseInt(orden) || 0,
    });

    setTimeout(() => {
      if (response.data.status === 200) {
        onSuccess?.();
      }
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
    }, 1000);
  };

  return (
    <div className="container-modal container-modal-edit-faq">
      <div className="modal modal-edit-faq">
        <div className="header-modal">
          <h3>Editar Pregunta Frecuente</h3>
          <button onClick={() => closeModal(".container-modal-edit-faq")}>
            <img src={CloseIcon} alt="" />
          </button>
        </div>
        <form onSubmit={handleSubmitFaq} className="body-modal">
          <div className="input">
            <label htmlFor="tituloEditFaq">Pregunta</label>
            <input
              type="text"
              id="tituloEditFaq"
              name="tituloEditFaq"
              required
              onChange={(e) => setTitulo(e.target.value)}
              value={titulo}
            />
          </div>
          <div className="input">
            <label htmlFor="respuestaEditFaq">Respuesta</label>
            <textarea
              id="respuestaEditFaq"
              name="respuestaEditFaq"
              required
              onChange={(e) => setRespuesta(e.target.value)}
              value={respuesta}
              rows={5}
            />
          </div>
          <div className="input">
            <label htmlFor="ordenEditFaq">Orden</label>
            <input
              type="number"
              id="ordenEditFaq"
              name="ordenEditFaq"
              onChange={(e) => setOrden(e.target.value)}
              value={orden}
              min={0}
            />
            <span className="hint">Determina el orden en que se muestra en la web (menor primero)</span>
          </div>

          <button className="btn-add-product">GUARDAR CAMBIOS</button>
        </form>
      </div>
    </div>
  );
};

export default ModalEditFaq;
